export enum SecondLoginStepsType {
  getGroundedExercise = "get-grounded-exercise",
  habitTracker = "habit-tracker",
  help = "help",
}
